/* eslint-disable import/prefer-default-export */
import * as Filter from './filter.alerts.reducer'
import type { AlertsInfo } from '@src/endpoints/services/intentMgr.service'
import { parseAlertDetails, AlertTab } from '@src/utils/alert.utils'

type ParsedAlertDetails = ReturnType<typeof parseAlertDetails>
export interface AlertDetails extends ParsedAlertDetails {}
export interface AlertItem extends AlertsInfo {
  entityTypes?: string
}

export const defaultState = {
  alertsList: [] as AlertItem[],
  alertDetail: {} as AlertDetails,
  isPending: false,
  isPendingGraph: true,
  error: null as any,
  pagesCount: 0,
  highCount: 0,
  mediumCount: 0,
  lowCount: 0,
  totalCount: 0,
  openCount: 0,
  alertTabs: [] as AlertTab[],
  filter: Filter.defaultState
}

export type AlertsState = typeof defaultState

export { Filter }
